import styled from "styled-components"
import Colors from "../../theme/Colors"
import { notPhone } from "../../theme/MediaQueries"

export const Container = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  min-height: 100vh;
`

export const HorizontalLine = styled.div`
  height: 1px;
  background-color: ${Colors.hr};
  ${notPhone} {
    margin-top: ${props => props.top || 0};
    margin-bottom: ${props => props.bottom || 0};
  }
`

export const LimitedWidth = styled.div`
  max-width: ${props => props.value || "1024px"};
  margin: 0 auto;
`
